module.exports = __webpack_public_path__ + "img/downArrow.f3bc3f05.svg";